/// <reference path='../_all.ts' />

module partner {
  'use strict';

  export class VendorResult {
    constructor(
      public Countries: Country[],
      public AreaData :  { [id: number]: AreaData; },
      public Vendors: { [id: number]: Vendor; },
      public DefaultVendor: Vendor,
      public LocationCountryCode: string,
      public BusinessAreas : BusinessArea[]
      ) { }
  }
}

